import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CLIENT_CASE_STUDIES } from '../client-case-studies';
import { ClientCaseStudyComponent } from '../shared/client-case-study/client-case-study.component';

@Component({
  selector: 'app-metaown',
  standalone: true,
  imports: [CommonModule, ClientCaseStudyComponent],
  templateUrl: './metaown.component.html',
  styleUrl: './metaown.component.scss'
})
export class MetaownComponent {
  readonly caseStudy = CLIENT_CASE_STUDIES.metaown;
}
